var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNightLife(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5H15L9 14V18H11V20H5V18H7V14L1 5ZM10.1 9L11.5 7H4.49L5.89 9H10.1ZM17 5H22V8H19V17C19 18.66 17.66 20 16 20C14.34 20 13 18.66 13 17C13 15.34 14.34 14 16 14C16.35 14 16.69 14.06 17 14.17V5Z",
    fill: "#003A5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNightLife);
export default __webpack_public_path__ + "static/media/night_life.57b4002f5873d1576bfdad5375a970e8.svg";
export { ForwardRef as ReactComponent };